import dayjs from 'dayjs';
import {
  IGetUserApprovalForPurchaseParams,
  TGetUserApproval,
  TGetUserApprovalDetail,
} from 'interfaces/Approve/Approve';

export interface IUpdateApprovalStatus {
  id: string;
  approvalYn: boolean;
}

export const APPROVE_VARIABLE = {
  getUserApproval: (params: TGetUserApproval) => {
    const {
      page,
      pageSize,
      date,
      approvalType,
      senderName,
      statusApproval,
      tuserApprovalDetail,
    } = params;

    return {
      take: pageSize,
      skip: (page - 1) * pageSize || 0,
      input: {
        ...(approvalType && {
          approvalId: {
            equals: approvalType,
          },
        }),
        ...(senderName && {
          tcreateUser: {
            fullName: {
              contains: senderName,
            },
          },
        }),
        ...(statusApproval && {
          statusApproval: {
            equals: statusApproval,
          },
        }),
        ...(tuserApprovalDetail && {
          tuserApprovalDetail: {
            email: {
              equals: tuserApprovalDetail,
            },
          },
        }),
        ...(date && {
          AND: [
            {
              createDate: {
                gte: dayjs(date).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
              },
            },
            {
              createDate: {
                lte: dayjs(date).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
              },
            },
          ],
        }),
      },
    };
  },
  // getUserApprovalById: (id: string) => {
  getUserApprovalById: (params: TGetUserApprovalDetail) => {
    const { id, tuserApprovalDetail } = params;
    return {
      input: {
        id: {
          equals: id,
        },
        ...(tuserApprovalDetail && {
          tuserApprovalDetail: {
            email: {
              equals: tuserApprovalDetail,
            },
          },
        }),
      },
    };
  },
  getApprovalStatus: () => {
    return {
      input: {
        groupId: { equals: 'AP100' },
      },
    };
  },
  getUserApprovalForPurchase: (params: IGetUserApprovalForPurchaseParams) => {
    return {
      input: {
        idConnect: { equals: params.idConnect },
        approvalId: { equals: params.approvalId },
        useYn: { equals: true },
      },
    };
  },
  getPurchaseApproval: (purchaseId: string) => {
    return {
      input: { purchaseId },
    };
  },
  getUserApprovalForOrder: (id: string) => {
    return {
      input: {
        id: { equals: id },
      },
    };
  },
  getOrderApproval: (orderId: string) => {
    return {
      input: { orderId },
    };
  },
  getUserCustomerApproval: (id: string) => {
    return {
      input: {
        userApprovalId: {
          equals: id,
        },
      },
    };
  },
  getCustomerApproval: (customerId: string) => {
    return {
      input: {
        id: { equals: customerId },
      },
    };
  },
  updateApprovalStatus: (params: IUpdateApprovalStatus) => {
    return {
      input: params,
    };
  },
};
